export default __webpack_public_path__ + "static/ethical-choice-59b1c4b3a6b2922246c81f6bf8c7e187.png";